import { render, staticRenderFns } from "./subsidy_record_list.vue?vue&type=template&id=f2173a40"
import script from "./subsidy_record_list.vue?vue&type=script&lang=js"
export * from "./subsidy_record_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports